var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81273 4.35534L9.625 3.25L8.67612 7.1042L7.4924 5.96783L5.58298 7.95681C5.51816 8.02433 5.4286 8.0625 5.335 8.0625C5.2414 8.0625 5.15185 8.02433 5.08702 7.95681L3.685 6.49637L1.62298 8.64431C1.4915 8.78126 1.2739 8.7857 1.13694 8.65423C0.999989 8.52275 0.995548 8.30515 1.12702 8.16819L3.43702 5.76194C3.50185 5.69442 3.5914 5.65625 3.685 5.65625C3.7786 5.65625 3.86816 5.69442 3.93298 5.76194L5.335 7.22238L6.99645 5.49171L5.81273 4.35534Z",
    fill: "#30322C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.b18543c2d784286be052d77212feb9e3.svg";
export { ForwardRef as ReactComponent };